import React, { useEffect, useState } from 'react'
import { withRouter, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Button, Divider, message } from 'antd'
import { getUser } from '../../../reducers'
import FormOutsourcing from '../../containers/FormOutsourcing'
import './newOutsourcingStyles.css'
import { cloudFunctions } from '../../../config/Fire'

const NewOutsourcing = props => {
    const [savingOutsourcing, setSavingOutsourcing] = useState(false)

    const saveWorkOrder = outsourcing => {
        setSavingOutsourcing(true)
        cloudFunctions.newOutsourcing(outsourcing)
            .then(response => {
                setSavingOutsourcing(false)
                if (response.data && response.data.code !== undefined && response.data.code === 0 && response.data.outsourcedOrder !== undefined) {
                    message.success('¡El proveedor se guardó exitósamente!')
                    props.onBack(true, response.data.outsourcedOrder)
                } else {
                    console.log(response)
                    message.error('Se produjo un error al guardar el proveedor. Por favor, vuelva a intentarlo')
                }
            })
            .catch(err => {
                setSavingOutsourcing(false)
                console.log(err)
                message.error('Se produjo un error al guardar el proveedor. Por favor, vuelva a intentarlo')
            })
    }

    return (
        <Grid className="newOutsourcingCont">
            <Row center="xs">
                <Col xs={12}>
                    <h2>Nuevo Proveedor</h2>
                </Col>
            </Row>
            <Divider/>
            <Row center="xs">
                <Col xs={12}>
                    <FormOutsourcing outsourcing={props.outsourcing}
                        onSubmitOutsourcing={saveWorkOrder}
                        isEditing={false}
                        loading={savingOutsourcing}/>
                </Col>
            </Row>
            <Row center="xs">
                <Col xs={6}>
                    <Button onClick={() => props.onBack(false)} disabled={savingOutsourcing} loading={savingOutsourcing}>
                        Salir
                    </Button>
                </Col>
            </Row>
        </Grid>
    )

}

NewOutsourcing.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(NewOutsourcing))